<template>
    <v-container>
        <v-toolbar flat>
            <v-card-actions>
                <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
                    mdi-arrow-left-thick
                </v-icon>
            </v-card-actions>
            
            <v-toolbar-title style=""><b>Add Course</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="form" @submit.prevent="saveCourse" class="custom_form">
            <v-card>
                <v-dialog persistent v-model="editTextDialog" width="900" height="800">
                    <EditText :editedText="toBeEditedText" @changeEditedText="changeEditedText($event)"/>
                </v-dialog>  
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Title</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="course.courseTitle"
                                outlined
                                dense 
                                clearable
                                @click="editTextTitle($event)"
                                :rules="courseTitleRules"
                                :success="courseTitleSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Description</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="course.courseDescription"
                                outlined
                                dense 
                                clearable
                                @click="editTextDescription($event)"
                                :rules="courseDescriptionRules"
                                :success="courseDescriptionSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Status</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="course.courseStatus"
                                ref="status"
                                inset
                                dense
                                class="mt-2" 
                                color="blue"
                                :label="course.courseStatus ? 'Active' : 'Inactive'"
                            >
                            <!-- @change="saveCourseStatus(item._id, item.courseStatus)" -->
                            </v-switch>
                        </v-col>
                    </v-row>


                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Paid</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="course.isPaid"
                                ref="ispaid"
                                inset
                                dense
                                class="mt-2" 
                                color="blue"
                                :label="course.isPaid ? 'Paid' : 'Free'"
                            >
                            <!-- @change="saveCourseStatus(item._id, item.courseStatus)" -->
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row v-if="errorMessage || successMessage">
                        <v-col cols="6" offset-md="2">
                            <v-alert v-if="errorMessage" type="error">
                                {{errorMessage}}
                            </v-alert>
                            <v-alert v-if="successMessage" type="success">
                                {{successMessage}}
                            </v-alert>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                                <v-btn
                                    class="mx-5"
                                    :disabled="disabled"
                                    type="submit"
                                    color="secondary"
                                    width="90"
                                    @click="saveCourse"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
import Course from "../../models/Course";
import EditText from "../../components/admin/EditText";
//import {mapMutations } from "vuex";
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                   vm.$router.push("/");
            }, 0);
        });
    },
    name: "AddCourse",
    components:{
        EditText
    },
    data() {
        return {
            course: new Course(),
            successMessage:'',
            errorMessage:'',
            disabled:false,
            toBeEditedText:'',
            editTextDialog:false,
            textField:null,
            inputType: '',
            //courseTitle:"abcd",
            //course.courseStatus:true,
            courseTitleSuccess:false,
            courseTitleRules: [
                v => {
                    if (v) {
                        this.courseTitleSuccess = true;
                        return true;
                    } else {
                        this.courseTitleSuccess = false;
                        return "title is required";
                    }
                },
                v => (v || "").length >= 2 || "Title must be at least 2 characters long", //to ask for the models
                v => (v || "").length <= 30 || "Title must be less than 30 characters" //to ask for the models, //earlier 30
            ],

            courseDescriptionSuccess: false,
            courseDescriptionRules: [
                v => {
                    if (v) {
                        this.courseDescriptionSuccess = true;
                        return true;
                    } else {
                        this.courseDescriptionSuccess = false;
                        return "Description is required";
                    }
                },
                v => (v || "").length >= 2 || "Description must be at least 2 characters long",
                v => (v || "").length <= 80 || "Description must be less than 80 characters",//earlier 255
            ],

            courseStatusSuccess:false, 
            courseStatusRules:[
                v=>(v===true||v===false)||"Status must be either true or false"
                // v => {
                //     if(v === true|| v === false) 
                //         return true;
                //     else 
                //         return false;
                // }
            ]
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    methods: {

        saveCourse() {
            this.disabled = true;
            //console.log('title', this.course.courseTitle);
            if (this.course.courseTitle.length<2 ||this.course.courseTitle.length>30) //earlier 30
            {
                this.errorMessage = 'Title should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.course.courseDescription.length<2 || this.course.courseDescription.length>80)//earlier 255
            {
                this.errorMessage = 'Description should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }
            //console.log('course status', this.course.courseStatus);
            
            if(!this.course.courseStatus)
            {
                this.course.courseStatus=false;
            }

            if(!this.course.isPaid)
            {
                this.course.isPaid=false;
            }

            if (!this.course.courseStatus===true && !this.course.courseStatus===false)
            {
                //console.log('course status inside', this.course.courseStatus);
                this.errorMessage = 'Status should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            Course.postCourse( this.course, this.auth.token)
            .then( res => {
                this.disabled = false;
                console.log('res', res);
                this.successMessage = 'Course added successfully';
                setTimeout(() => (this.successMessage = ""), 5000);
                this.$refs.form.reset();
            //    this.course.courseTitle='';
            //    this.course.courseDescription='';
                this.course.courseStatus=false;
                this.course.isPaid=false;

                //this.course.courseStatus=true;
            })
            .catch( err => {
                this.errorMessage = err.response.data;
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                this.$refs.form.reset(); 
            //    this.course.courseTitle='';
            //    this.course.courseDescription='';
                this.course.courseStatus=false;
                this.course.isPaid=false;

                //this.course.courseStatus=true;
            });
        },

        clearForm(){
            this.$refs.form.resetValidation();
        },

        editTextTitle(e){
            this.textField=e.target;
            this.textField.blur();
            e.target.value="abc";
            //console.log('tag name', e.target.tagName);
            this.inputType="title"
            this.toBeEditedText=this.course.courseTitle;
            this.editTextDialog=true;
            //console.log('test edited text title 2');
        },

        editTextDescription(e){
            this.textField=e.target;
            this.textField.blur();
            this.inputType="desc"
            this.toBeEditedText=this.course.courseDescription;           
            this.editTextDialog=true;
        },

        changeEditedText(editedText) {
            if(editedText===null)
            {
                this.editTextDialog=false;
            }
            else
            {
                //console.log("Selected: "+ this.inputType );
                this.toBeEditedText=editedText;
                if(this.inputType == 'title') 
                {
                    this.course.courseTitle = editedText;
                }
                else  if(this.inputType == 'desc') {
                    this.course.courseDescription = editedText; 
                }
            }
            this.editTextDialog = false;
            //this.textField.focus();
            // this.$nextTick(() => {
            //                 this.textField.focus();//textField.setSelectionRange(this.cursorPos, this.cursorPos)
            //             })
        }
    }, 
    mounted(){

    }
}
</script>
<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
</style>